/**
 * `'deferred_payment'` is deliberately absent; no gate in this portal keys on
 * it yet. Duplicated by design (no shared workspace) in
 * `clients/nuur-app/src/lib/products.ts` and
 * `clients/mazeedpay-app/src/lib/products.ts` — keep all three in sync.
 */
export const PRODUCTS = {
  deviceFinancing: 'device_financing',
  payInInstallments: 'pay_in_installments',
} as const;

export type ProductCode = (typeof PRODUCTS)[keyof typeof PRODUCTS];

/**
 * `null` while `/tenants/resolve` hasn't answered yet — not interchangeable
 * with a resolved empty list; see `isProductWithheld` in `./product-scopes`.
 */
export type TenantProducts = readonly string[] | null;

/**
 * `null` (unresolved) reads as "no". A caller that must fail open while
 * unresolved instead wants `isProductWithheld`.
 */
export function hasProduct(code: ProductCode, products: TenantProducts): boolean {
  return products?.includes(code) ?? false;
}
